import {
	CreateDrawerFormProps,
	FormDrawer,
	FormDrawerContent,
	FormDrawerContentProps,
	FormFetchDrawer,
	TextField,
	UpdateDrawerFormProps,
	isExternalUrl,
} from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { createCampaignUrlService } from "../shared/api/createCampaignUrlService";
import { ICampaignUrlIndexResource, ICampaignUrlRequest } from "../shared/types";

const useValidate = () => {
	const { t } = useTranslation();

	return (values: ICampaignUrlRequest) => {
		const errors: { [K in keyof ICampaignUrlRequest]?: any } = {};

		if (!values.slug) {
			errors.slug = t("Required field");
		} else if (!new RegExp("^[a-z0-9]+(?:-[a-z0-9]+)*$").test(values.slug)) {
			errors.slug = t("The slug may only contain a-z, 0-9 and separating dashes.");
		}
		if (!values.targetUrl) {
			errors.targetUrl = t("Required field");
		} else if (!isExternalUrl(values.targetUrl)) {
			errors.targetUrl = t("The URL must be a valid external URL.");
		}
		return errors;
	};
};

const CampaignUrlFormDrawerContent: FC<FormDrawerContentProps> = (props) => {
	const { t } = useTranslation();

	return (
		<FormDrawerContent {...props}>
			<TextField name="slug" label={t("Slug")} required />
			<TextField name="targetUrl" label={t("Target URL")} required />
		</FormDrawerContent>
	);
};

export const CampaignUrlCreateDrawer: FC<CreateDrawerFormProps<ICampaignUrlRequest>> = (props) => {
	const { t } = useTranslation();
	const validate = useValidate();
	const initialValues: ICampaignUrlRequest = { slug: "", targetUrl: "" };

	return (
		<FormDrawer
			{...props}
			initialValues={initialValues}
			title={t("Create campaign URL")}
			validate={validate}
			renderForm={(props) => <CampaignUrlFormDrawerContent {...props} />}
		/>
	);
};

export const CampaignUrlUpdateDrawer: FC<
	UpdateDrawerFormProps<ICampaignUrlIndexResource> & { service: ReturnType<typeof createCampaignUrlService> }
> = (props) => {
	const { t } = useTranslation();
	const validate = useValidate();

	return (
		<FormFetchDrawer
			{...props}
			title={t("Edit campaign")}
			queryFn={() => props.service.show(props.id).then((x) => x.data.data)}
			queryKey={props.service.showKey(props.id)}
			validate={validate}
			renderSuccess={(props) => <CampaignUrlFormDrawerContent {...props} />}
		/>
	);
};
